import React from 'react';
import { Tabs, Tab, Box } from '@mui/material';
import PropTypes from 'prop-types';

function ResponsiveTabs({ items, spreadWidth, value, onChange }:any) {
  return (
    <Box className="rounded-2" sx={{ width: '100%', bgcolor: 'background.paper' }}>
      <Tabs
        
        value={value}
        onChange={onChange}
        variant={spreadWidth ? 'fullWidth' : 'scrollable'}
        indicatorColor="primary"  
        textColor="primary"
        aria-label="responsive tabs example"
      >
        {items.map((item:any, index:any) => (
          <Tab label={item.title} key={index} />
        ))}
      </Tabs>
    </Box>
  );
}

ResponsiveTabs.propTypes = {
  items: PropTypes.array.isRequired,
  spreadWidth: PropTypes.bool,
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default ResponsiveTabs;
